import { createSlice } from "@reduxjs/toolkit";
import { Station } from "src/types/station";
import { RYNAN_STATION_GET_ALL, RYNAN_STATION_SET_SELECTED } from "./action";

interface RynanStationState {
  stations: Station[];
  selectedStation: Station | null;
}

const initialState: RynanStationState = {
  stations: [],
  selectedStation: null,
};

const rynanStationSlice = createSlice({
  name: "rynanStation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(RYNAN_STATION_GET_ALL, (state, action) => {
      state.stations = action.payload.stations;
    });
    builder.addCase(RYNAN_STATION_SET_SELECTED, (state, action) => {
      state.selectedStation = action.payload.station;
    });
  },
});

export default rynanStationSlice.reducer;
